import React from "react";
import dxlWordmark from "../../assets/dxl-wordmark.png";

export function DxlLogo({ className = "", alt = "DXL — Digital Experience Leaders" }) {
  return <img src={dxlWordmark} alt={alt} className={`dxl-logo ${className}`.trim()} />;
}
